<template lang="pug">
.login
   nav.flex.items-center.justify-between.flex-wrap.p-6.flex.items-center.flex-no-shrink.text-white.pb-4
      a.px-3.py-2.text-white.text-3xl(href='#/')
         img#logo(src="@/assets/logo2.svg" title="gootics")
      div
      a.no-underline(href="#" title="Dark Mode" @click.prevent="setMode('darkmode')" v-if="colorMode != 'darkmode'") 🌒
      a.no-underline(href="#" title="Light Mode" @click.prevent="setMode('lightmode')" v-else) ☀️
   router-view
</template>

<script>
export default {
  name: 'LoginView',
  store: ['colorMode'],
  components: {
  },
  created () {
    if (localStorage.getItem('darkmode') === 'darkmode') {
      let body = document.body
      body.classList.remove('lightmode')
      body.classList.add('darkmode')
      this.colorMode = 'darkmode'
    }
  },
  methods: {
    setMode (mode) {
      let body = document.body
      let oldClassName = 'lightmode'
      if (mode === 'lightmode') oldClassName = 'darkmode'
      this.colorMode = mode
      body.classList.remove(oldClassName)
      body.classList.add(mode)
      localStorage.setItem('darkmode', mode)
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LoginView.vue